import http from "@/utils/http";


export const WechatOpenOauthApi = {

    render(params) {
        return http.get(`/server/wechat/oauth/render`,params)
    },
    binding(data) {
        return http.post(`/server/wechat/oauth/binding`,data)
    },

}